<template>
  <div class="category-filter">
    <b-row class="categories" align-v="stretch">
      <b-col
        v-for="category in articleCategories"
        :key="category.id"
        v-show="(toggled && !category.isEmpty) || !toggled"
        cols="6"
        md="4"
        lg="4"
        xl="3"
      >
        <router-link
          :to="{
            name: 'articles-in-category',
            params: {
              title: category.title,
              alias: category.alias,
              id: category.id,
            },
          }"
        >
          <b-card
            no-body
            :class="
              !category.isEmpty
                ? 'focusable text-center h-100'
                : 'focusable text-center h-100 is-empty'
            "
            contenteditable="true"
            onkeydown="if(event.metaKey || event.ctrlKey || event.key === 'Tab') return true; return false;"
          >
            <b-card-body>
              <span class="icon">
                <i
                  :class="category.icon || 'fas fa-circle'"
                  class="text-success"
                ></i>
              </span>
              <b-card-title>
                {{ category.title }}
              </b-card-title>
            </b-card-body>
          </b-card>
        </router-link>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BCard, BCardBody, BCardTitle } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CategoryFilter",
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardTitle,
  },

  data() {
    return {
      articleCategories: [],
      empty: [],
      toggled: false,
    };
  },
  mounted() {
    this.$nextTick(async function() {
      // toggle
      this.toggled = await this.fetchToggleState(this.$currentUserId());

      let emptyCategories = [];
      let fountContacts = false;

      for (let cat of this.categories) {
        cat.isEmpty = true;

        if (this.title !== cat.description) {
          continue;
        }
        if (cat.title == "Viktiga personer") {
          const contacts = this.getContacts;
          for (let con of contacts) {
            const access_groups = con.access_groups;
            for (let ag of access_groups) {
              if (ag.title == "Viktig person") {
                cat.isEmpty = false;
                fountContacts = true;

                break;
              }
            }
            if (fountContacts) {
              break;
            }
          }
          emptyCategories.push(cat);
          continue;
        }

        const articles = this.getArticlesByCategory(cat.id).filter(
          (a) => !a.is_news_article && !a.is_about_me
        );
        const articlesInDraft = articles.filter((a) => true !== a.published);
        if (articles.length > 0 && articles.length != articlesInDraft.length) {
          cat.isEmpty = false;
          this.articleCategories.push(cat);
        } else {
          emptyCategories.push(cat);
        }
      }

      this.articleCategories.push(...emptyCategories);
    });
  },
  methods: {
    ...mapActions("userAccount", ["fetchToggleState"]),
  },
  computed: {
    ...mapGetters({ categories: "getArticleCategories" }),
    ...mapGetters(["getArticlesByCategory"]),
    ...mapGetters("userAccount", ["isToggle"]),
    ...mapGetters(["contacts", "getContacts"]),
  },
  watch: {
    // Watcher for the 'isToggle' computed property
    isToggle(newVal) {
      this.toggled = newVal;
    },
  },

  props: {
    title: String,
  },
};
</script>
<style lang="scss" scoped>
@import "src/assets/scss/variables/_variables.scss";
a .card-title {
  color: $primary;
}
// .card {
//     border: 1px solid $primary;
// }
.card:hover {
  box-shadow: 0 8px 25px -8px $primary;
}
.quick-search .btn {
  border: 0 !important;
  background-color: #fff;
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
}
.dark-layout .quick-search .btn {
  background-color: #283046;
}
.quick-search span {
  color: $green;
}
</style>
<style scoped>
.card {
  margin-bottom: 0;
}

.card.is-empty:before {
  border-radius: 100px;;
  padding:5px;
  color: #7367f0;
  font-size: 12px;
  display: block;
  position: absolute;
  font-family: 'Tahoma', sans-serif;
  height:fit-content;
  content: '(tom)';
  right: 2px;
  top: 2px;
}


.card:hover {
  cursor: pointer;
}
.card-title {
  margin-bottom: 0;
}
.icon {
  font-size: 3.75rem;
  margin-bottom: 1rem;
}
a {
  color: inherit;
}
@media screen and (max-width: 576px) {
  .quick-search span {
    display: block;
    margin-bottom: 4px;
  }
  .row {
    margin-right: -0.5rem;
    margin-left: -0.5rem;
  }
  .col-6,
  .col-4 {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .col-6 {
    margin-bottom: 1rem;
  }
  .card {
    margin-bottom: 0;
  }
  .card-title {
    font-size: 0.95rem;
  }
}
@media screen and (min-width: 576px) {
  .col-6 {
    margin-bottom: 2rem;
  }
}
</style>
